/*
 * fdp-search storefront client (github.com/moshebrackman/fdp-search, theme/).
 * - Predictive dropdown: replaces PredictiveSearch#getSearchResults so the theme's own dropdown shows Meilisearch results.
 * - /search page: drives sections/fdp-meili-search.liquid (filters, sort, pagination).
 * Meilisearch only ranks and selects products. Cards are rendered by Shopify (templates/search.fdp-cards*.liquid)
 * so prices — including B2B catalog prices — are always what Shopify would show this shopper.
 */
(function () {
  "use strict";
  var CFG = window.FDP_MEILI;
  if (!CFG || !CFG.host || !CFG.key) return;

  // Pack phrases expand pack-size families (e.g. "6 pack", "case of 48"); otherwise one card per family.
  var PACK_RE = /\b(\d+\s*-?\s*(pack|pk|ct|count|pcs|pieces)|case of \d+|pack of \d+|case|bulk|wholesale)\b/i;
  var CARD_BATCH = 20; // all_products allows 20 distinct handles per render
  var FIRST_PAINT = 8; // paint the first row quickly (~350 ms), then fill in the rest
  // Everything an instant card needs, so no Shopify round-trip is required to paint results.
  var CARD_FIELDS = ["handle", "title", "url", "image", "price_min", "compare_at_max", "discount_pct",
    "rating", "rating_count", "in_stock", "family_options", "family_size", "pack_label", "variant_id", "variant_count"];

  var FACETS = [
    { attr: "category1", label: "Category" },
    { attr: "category2", label: "Product type" },
    { attr: "license", label: "Character & license" },
    { attr: "themes", label: "Theme" },
    { attr: "occasion", label: "Occasion" },
    { attr: "color", label: "Color" },
    { attr: "size", label: "Size" },
    { attr: "material", label: "Material" },
  ];
  var PRICE_RANGES = [
    { id: "0-5", label: "Under $5", filter: "price_min < 5" },
    { id: "5-15", label: "$5 – $15", filter: "price_min >= 5 AND price_min < 15" },
    { id: "15-30", label: "$15 – $30", filter: "price_min >= 15 AND price_min < 30" },
    { id: "30-60", label: "$30 – $60", filter: "price_min >= 30 AND price_min < 60" },
    { id: "60+", label: "$60 and up", filter: "price_min >= 60" },
  ];

  // ---------------------------------------------------------------------------------------------
  // helpers

  function cleanQuery(q) {
    return String(q || "")
      .replace(/\s*product_type:\s*"[^"]*"/gi, "")
      .replace(/\*/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function quote(v) {
    return '"' + String(v).replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"';
  }

  /** Keyword -> collection redirect from the "FDP Custom Header Search" section, if enabled. */
  function redirectFor(term) {
    var t = cleanQuery(term).toLowerCase();
    if (!t || !window.fdpCustomSearchEnabled || !window.fdpCustomSearchKeywords) return null;
    var map = window.fdpCustomSearchKeywords;
    for (var url in map) {
      if (map[url].some(function (k) { return String(k).toLowerCase().trim() === t; })) return url;
    }
    return null;
  }

  function meiliSearch(body) {
    return fetch(CFG.host + "/indexes/" + CFG.index + "/search", {
      method: "POST",
      headers: { Authorization: "Bearer " + CFG.key, "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) throw new Error("search failed: " + r.status);
      return r.json();
    });
  }

  function baseFilters() {
    return CFG.hideOutOfStock ? ["in_stock = true"] : [];
  }

  /**
   * Looser versions of an over-specific query, most specific first: drop numbers (e.g. "72"), then words from the end.
   * "green fork 72" -> ["green fork", "green"].
   */
  function relaxations(q) {
    var words = q.split(" ").filter(Boolean);
    if (words.length < 2) return [];
    var order = [], i;
    for (i = words.length - 1; i >= 0; i--) if (/\d/.test(words[i])) order.push(i);
    for (i = words.length - 1; i >= 0; i--) if (!/\d/.test(words[i])) order.push(i);
    var dropped = {}, out = [];
    for (i = 0; i < order.length - 1; i++) {
      dropped[order[i]] = true;
      out.push(words.filter(function (_w, j) { return !dropped[j]; }).join(" "));
    }
    return out;
  }

  /** First relaxation of `q` that has results under the same filters, or null. One multi-search, counts only. */
  function findRelaxed(q, filter, distinct) {
    var candidates = relaxations(q);
    if (!candidates.length) return Promise.resolve(null);
    var queries = candidates.map(function (c) {
      var body = { indexUid: CFG.index, q: c, matchingStrategy: "all", filter: filter, limit: 1, attributesToRetrieve: ["id"] };
      if (distinct) body.distinct = "family";
      return body;
    });
    return fetch(CFG.host + "/multi-search", {
      method: "POST",
      headers: { Authorization: "Bearer " + CFG.key, "Content-Type": "application/json" },
      body: JSON.stringify({ queries: queries }),
    })
      .then(function (r) { return r.ok ? r.json() : { results: [] }; })
      .then(function (data) {
        for (var i = 0; i < data.results.length; i++) if (data.results[i].hits.length) return candidates[i];
        return null;
      });
  }

  // ---------------------------------------------------------------------------------------------
  // Search analytics (Shopify admin → Search analytics). Anonymous: a random per-tab id, no cookies,
  // no customer data. Batched and sent with sendBeacon so it never slows the page.

  var sid = (function () {
    try {
      var v = sessionStorage.getItem("fdp_sid");
      if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem("fdp_sid", v); }
      return v;
    } catch (e) { return Math.random().toString(36).slice(2); }
  })();
  var queue = [], flushTimer = null;
  // Only the published theme reports (previews would pollute the numbers); ?fdp_track=1 enables it for QA.
  var tracking = (function () {
    if (CFG.b2b) return false; // company buyers aren't part of the retail search numbers
    try {
      if (/[?&]fdp_track=1/.test(location.search)) sessionStorage.setItem("fdp_track", "1");
      return (window.Shopify && Shopify.theme && Shopify.theme.role === "main") || sessionStorage.getItem("fdp_track") === "1";
    } catch (e) { return false; }
  })();

  function flush() {
    clearTimeout(flushTimer); flushTimer = null;
    if (!queue.length || !CFG.eventsUrl) return;
    var body = JSON.stringify({ sid: sid, events: queue.splice(0, 25) });
    try {
      if (!(navigator.sendBeacon && navigator.sendBeacon(CFG.eventsUrl, new Blob([body], { type: "text/plain" })))) {
        fetch(CFG.eventsUrl, { method: "POST", body: body, keepalive: true, mode: "no-cors" });
      }
    } catch (e) { /* analytics must never break search */ }
    if (queue.length) flush();
  }
  function log(ev) {
    if (!tracking || !CFG.eventsUrl || !ev.q) return;
    queue.push(ev);
    if (queue.length >= 10) flush(); else if (!flushTimer) flushTimer = setTimeout(flush, 3000);
  }
  document.addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden") flush(); });
  window.addEventListener("pagehide", flush);

  /** Remember the search behind a product click, so an add to cart on the product page counts too. */
  function rememberClick(q, handle) {
    try { sessionStorage.setItem("fdp_last_click", JSON.stringify({ q: q, handle: handle, at: Date.now() })); } catch (e) { /* ignore */ }
  }

  function handleFromLink(a) {
    var m = (a.getAttribute("href") || "").match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  /** Clicks and add-to-carts inside a results container. `getQuery` returns the search they belong to. */
  function trackContainer(root, source, getQuery, beforeClick) {
    root.addEventListener("click", function (e) {
      var q = getQuery();
      if (!q) return;
      var card = e.target.closest("[data-fdp-handle]");
      if (!card) return;
      var handle = card.dataset.fdpHandle;
      var addBtn = e.target.closest('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button, .fdp-c__add');
      if (addBtn && !addBtn.classList.contains("fdp-c__add")) {
        log({ type: "add_to_cart", source: source, q: q, handle: handle });
        return;
      }
      var link = e.target.closest('a[href*="/products/"]');
      if (!link) return;
      if (beforeClick) beforeClick();
      var cards = [].slice.call(root.querySelectorAll("[data-fdp-handle]"));
      log({ type: "click", source: source, q: q, handle: handle || handleFromLink(link), position: cards.indexOf(card) + 1 });
      rememberClick(q, handle);
      flush(); // the page is about to change
    }, true);
  }

  /** Product page: an add to cart within 30 minutes of clicking a search result counts for that search. */
  function trackProductPageAddToCart() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var last;
    try { last = JSON.parse(sessionStorage.getItem("fdp_last_click") || "null"); } catch (e) { last = null; }
    if (!last || last.handle !== decodeURIComponent(m[1]) || Date.now() - last.at > 30 * 60 * 1000) return;
    document.addEventListener("click", function (e) {
      if (!e.target.closest('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"]')) return;
      log({ type: "add_to_cart", source: "product", q: last.q, handle: last.handle });
      flush();
    }, true);
  }

  var cardCache = {}; // view|handle -> html

  /** Render Shopify cards for handles (in order). Returns [{handle, html}] for products the shopper can see. */
  function renderCards(handles, view) {
    var missing = handles.filter(function (h) { return !((view + "|" + h) in cardCache); });
    var batches = [];
    for (var i = 0; i < missing.length; i += CARD_BATCH) batches.push(missing.slice(i, i + CARD_BATCH));
    return Promise.all(
      batches.map(function (batch) {
        var url = CFG.searchUrl + "?type=page&view=" + view + "&q=" + encodeURIComponent(batch.join(" "));
        return fetch(url, { credentials: "same-origin" })
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, "text/html");
            batch.forEach(function (h) { cardCache[view + "|" + h] = null; }); // not visible to this shopper
            doc.querySelectorAll("[data-fdp-handle]").forEach(function (el) {
              if (!el.dataset.fdpHandle) return; // Liquid found no storefront product for that handle
              var hideIt = CFG.hideOutOfStock && (el.dataset.fdpAvailable !== "true" || el.dataset.fdpImage !== "true");
              cardCache[view + "|" + el.dataset.fdpHandle] = hideIt ? null : el.outerHTML;
            });
          });
      })
    ).then(function () {
      return handles
        .map(function (h) { return { handle: h, html: cardCache[view + "|" + h] }; })
        .filter(function (c) { return c.html; });
    });
  }

  function money(n) {
    return "$" + Number(n || 0).toFixed(2);
  }

  function stars(rating, count) {
    if (!count) return "";
    var r = Math.round((rating || 0) * 2) / 2, out = "";
    for (var i = 1; i <= 5; i++) out += i <= r ? "★" : i - 0.5 === r ? "⯪" : "☆";
    return '<span class="fdp-c__stars">' + out + ' <span class="fdp-c__rc">(' + count + ")</span></span>";
  }

  function img(url, w) {
    if (!url) return "";
    return url.indexOf("?") > 0 ? url + "&width=" + w : url + "?width=" + w;
  }

  /**
   * Card drawn straight from the index — no Shopify request, so results paint as soon as Meilisearch answers.
   * Shopify's own card replaces it a moment later (and is used from the start for B2B, whose prices differ).
   */
  function isMobile() {
    return window.matchMedia && window.matchMedia("(max-width: 767px)").matches;
  }

  var MOBILE_ROWS = 6; // how many products the phone dropdown lists

  /** Compact row for the mobile dropdown: small thumbnail and the product name, nothing else. */
  function instantRow(hit) {
    return (
      '<div class="product fdp-row" data-fdp-handle="' + esc(hit.handle) + '" data-fdp-instant="1">' +
      '<a class="fdp-row__link" href="' + esc(hit.url) + '">' +
      '<span class="fdp-row__media">' + (hit.image ? '<img src="' + esc(img(hit.image, 88)) + '" alt="" loading="lazy" width="44" height="44">' : "") + "</span>" +
      '<span class="fdp-row__title">' + esc(hit.title) + "</span>" +
      "</a></div>"
    );
  }

  function instantCard(hit, tag) {
    var packs = (hit.family_options || []).filter(function (o) { return o.in_stock !== false; }).map(function (o) { return o.label; });
    var sale = hit.compare_at_max > hit.price_min;
    return (
      "<" + tag + ' class="product fdp-c" data-fdp-handle="' + esc(hit.handle) + '" data-fdp-instant="1">' +
      '<a class="fdp-c__media" href="' + esc(hit.url) + '" tabindex="-1" aria-hidden="true">' +
      (hit.image ? '<img src="' + esc(img(hit.image, 400)) + '" alt="" loading="lazy" width="400" height="400">' : "") +
      (hit.family_size > 1 && hit.pack_label ? '<span class="fdp-c__pack">' + esc(hit.pack_label) + "</span>" : "") +
      "</a>" +
      '<div class="fdp-c__body">' +
      stars(hit.rating, hit.rating_count) +
      '<a class="fdp-c__title" href="' + esc(hit.url) + '">' + esc(hit.title) + "</a>" +
      '<div class="fdp-c__price">' +
      '<span class="fdp-c__now' + (sale ? " is-sale" : "") + '">' + money(hit.price_min) + "</span>" +
      (sale ? '<s class="fdp-c__was">' + money(hit.compare_at_max) + "</s>" : "") +
      (sale && hit.discount_pct ? '<span class="fdp-c__off">' + hit.discount_pct + "% OFF</span>" : "") +
      "</div>" +
      (packs.length > 1 ? '<div class="fdp-c__packs">Also: ' + packs.slice(1, 4).map(esc).join(" · ") + "</div>" : "") +
      (hit.in_stock === false ? '<div class="fdp-c__oos">Out of stock</div>' : "") +
      // Same shape as the Shopify card that replaces this one, so nothing shifts when it arrives.
      '<div class="fdp-c__actions"><span class="fdp-c__qty">1</span>' +
      '<a class="fdp-c__add" href="' + esc(hit.url) + '">+ Add</a></div>' +
      "</div></" + tag + ">"
    );
  }

  /** Let theme scripts (lazy images, swatches, quick add) pick up injected cards. */
  function afterCardsInserted(root) {
    try {
      document.dispatchEvent(new CustomEvent("fdp:cards-rendered", { detail: { root: root } }));
      if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.checkElems();
      if (window.halo && typeof window.halo.productBlockInit === "function") window.halo.productBlockInit();
    } catch (e) { /* theme helpers are optional */ }
  }

  function track(event, data) {
    try {
      if (window.dataLayer) window.dataLayer.push(Object.assign({ event: "fdp_search_" + event }, data));
    } catch (e) { /* ignore */ }
  }

  // ---------------------------------------------------------------------------------------------
  // Shopify's own search (templates/search.native.json): used by B2B sessions, and as the fallback
  // when Meilisearch can't be reached.

  function nativeSearchUrl(href) {
    var u = new URL(href || location.href, location.origin);
    u.searchParams.set("view", "native");
    return u.toString();
  }

  /** B2B: send every search form and search link to Shopify's results page. */
  function useNativeSearch() {
    document.querySelectorAll('form[action*="/search"]').forEach(function (f) {
      if (f.querySelector('input[name="view"]')) return;
      var i = document.createElement("input");
      i.type = "hidden"; i.name = "view"; i.value = "native";
      f.appendChild(i);
    });
    document.addEventListener("click", function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/search?"]');
      if (!a || /[?&]view=/.test(a.getAttribute("href"))) return;
      a.setAttribute("href", nativeSearchUrl(a.getAttribute("href")));
    }, true);
  }

  // ---------------------------------------------------------------------------------------------
  // predictive dropdown

  /**
   * Categories worth offering as a narrowing step: drop the long tail, and put categories whose name
   * matches what was typed first ("red tabl" -> Rectangle Table Covers before Mylar Balloons).
   */
  function categoryChips(term, res, attr) {
    var dist = (res.facetDistribution && res.facetDistribution[attr]) || {};
    var words = term.toLowerCase().split(/\s+/).filter(function (w) { return w.length > 2; });
    var names = Object.keys(dist).filter(function (v) { return dist[v] >= 2; });
    if (names.length < 2) return [];
    var score = function (name) {
      var low = name.toLowerCase();
      var hits = words.filter(function (w) {
        return low.split(/\s+/).some(function (part) { return part.indexOf(w) === 0 || w.indexOf(part) === 0; });
      }).length;
      return hits;
    };
    return names
      .sort(function (a, b) { return score(b) - score(a) || dist[b] - dist[a] || a.localeCompare(b); })
      .slice(0, 5)
      .map(function (v) { return { value: v, attr: attr, count: dist[v] }; });
  }

  function dropdownMarkup(term, res, cards, relaxedTo, rows) {
    var perRow = (window.theme && window.theme.settings && window.theme.settings.search_product_per_row) || 4;
    var suggestions = categoryChips(term, res, "category3");
    if (suggestions.length < 2) suggestions = categoryChips(term, res, "category2");

    var viewAll = CFG.searchUrl + "?q=" + encodeURIComponent(term) + "&type=product";
    var html = '<div id="predictive-search-results" class="quickSearchResults quickSearchResultsBlock custom-scrollbar"><div class="container">';
    html += '<div id="predictive-search-results-list" class="predictive-search__results-list list-unstyled" role="listbox" aria-labelledby="predictive-search-products">';
    if (rows) suggestions = []; // phones show just the product list, like Amazon
    if (suggestions.length) {
      html += '<div class="fdp-search-suggestions"><span id="predictive-search-queries" class="predictive-search__heading text-body caption-with-letter-spacing">Suggestions</span>';
      html += '<ul id="predictive-search-results-queries-list" class="predictive-search__results-list list-item list-unstyled clearfix" role="group" aria-labelledby="predictive-search-queries">';
      suggestions.forEach(function (sg, i) {
        var href = CFG.searchUrl + "?q=" + encodeURIComponent(relaxedTo || term) + "&type=product&f." + sg.attr + "=" + encodeURIComponent(sg.value);
        // Plain text: the theme bolds the typed words inside .predictive-search__query-text.
        html += '<li id="predictive-search-option-query-' + (i + 1) + '" class="predictive-search__list-item item" role="option" aria-selected="false">' +
          '<a href="' + esc(href) + '" class="predictive-search__item link link--text" tabindex="-1"><span class="text predictive-search__query-text">' +
          esc(relaxedTo || term) + " in " + esc(sg.value) + "</span></a></li>";
      });
      html += "</ul></div>";
    }
    if (relaxedTo) {
      html += '<p class="fdp-search-relaxed" style="margin:0 0 10px;font-size:14px">No exact matches for “' + esc(term) + '”. Showing results for “<strong>' + esc(relaxedTo) + '</strong>”.</p>';
    }
    if (!rows) {
      html += '<h2 id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing search-block-title text-left"><span class="text">Products</span></h2>';
    }
    if (cards.length) {
      html += rows
        ? '<div id="predictive-search-results-products" class="fdp-rows text-left">'
        : '<div id="predictive-search-results-products" class="products-grid products-section column-' + perRow + ' disable-srollbar text-left">';
      cards.forEach(function (c) { html += c.html; });
      html += "</div>";
      html += '<div id="predictive-search-option-search-keywords" class="predictive-search__list-item productViewAll" role="option">' +
        '<a href="' + esc(viewAll) + '" class="predictive-search__item predictive-search__item--term link link--text h5 animate-arrow button button-view-all" tabindex="-1" data-qs-view-all-link>' +
        "View all " + res.estimatedTotalHits + " results</a></div>";
    } else {
      html += '<p class="predictive-search__item-heading">No products found for “' + esc(term) + "”.</p>";
    }
    html += "</div></div></div>";
    return html;
  }

  function logDropdownSearch(ps) {
    clearTimeout(ps.__fdpLogTimer);
    var p = ps.__fdpPending;
    if (!p || ps.__fdpLogged === p.q) return;
    ps.__fdpLogged = p.q;
    log(p);
  }

  function patchPredictiveSearch() {
    var PS = customElements.get("predictive-search");
    if (!PS || PS.prototype.__fdpMeili) return;
    PS.prototype.__fdpMeili = true;
    var shopifyResults = PS.prototype.getSearchResults; // theme's own (Shopify predictive search)
    // On phones the dropdown only exists once there's a query: no "Trending Now" panel on focus.
    var showTrending = PS.prototype.showTrendingAndProducts;
    PS.prototype.showTrendingAndProducts = function () {
      if (isMobile()) {
        if (this.close) this.close(true);
        return;
      }
      return showTrending.apply(this, arguments);
    };

    // Lowering the phone keyboard blurs the input, and the theme closes the panel on any focus loss.
    // Its focusout listener is bound in the constructor (before this script runs), so stop the event
    // in the capture phase instead. On phones the results stay open while there's a query; the X button
    // or a tap outside the search still closes them.
    document.querySelectorAll("predictive-search").forEach(function (el) {
      trackContainer(el, "dropdown",
        function () { return el.__fdpPending ? el.__fdpPending.q : cleanQuery(el.getQuery ? el.getQuery() : ""); },
        function () { logDropdownSearch(el); });
      el.addEventListener("focusout", function (e) {
        if (isMobile() && el.getQuery && el.getQuery().length && el.predictiveSearchResults && el.predictiveSearchResults.innerHTML.trim()) {
          e.stopImmediatePropagation();
        }
      }, true);
    });

    // The theme waits 1000 ms after the last keystroke before searching at all — that was sized for
    // Shopify's predictive API. Meilisearch answers in ~120 ms, so search as soon as typing pauses.
    PS.prototype.onChange = function () {
      var term = this.getQuery();
      clearTimeout(this.typingTimer);
      if (!term.length) {
        this.predictiveSearchResults.innerHTML = "";
        this.removeAttribute("results");
        this.close(true);
        if (this.showTrendingAndProducts) this.showTrendingAndProducts();
        return;
      }
      if (!this.predictiveSearchResults.innerHTML && this.open) this.open();
      this.getSearchResults(term); // debounced below
    };

    PS.prototype.getSearchResults = function (searchTerm) {
      var self = this;
      var term = cleanQuery(this.getQuery ? this.getQuery() : searchTerm);
      if (!term) return;
      var seq = (this.__fdpSeq = (this.__fdpSeq || 0) + 1);
      if (!this.predictiveSearchResults.innerHTML && this.setLiveRegionLoadingState) this.setLiveRegionLoadingState();
      var limit = Math.max(4, Math.min(12, parseInt(CFG.dropdownLimit, 10) || 8));
      clearTimeout(this.__fdpTimer); // one request per pause in typing, not per keystroke
      var body = {
        q: term,
        limit: limit + 2, // spare hits in case some aren't visible to this shopper
        matchingStrategy: "all",
        attributesToRetrieve: CARD_FIELDS,
        facets: ["category3", "category2"],
        filter: baseFilters(),
      };
      if (!PACK_RE.test(term)) body.distinct = "family";
      var relaxedTo = null;
      this.__fdpTimer = setTimeout(function () { runQuery(); }, 60);

      function runQuery() {
      meiliSearch(body)
        .then(function (res) {
          if (res.hits.length) return res;
          return findRelaxed(term, body.filter, Boolean(body.distinct)).then(function (alt) {
            if (!alt) return res;
            relaxedTo = alt;
            return meiliSearch(Object.assign({}, body, { q: alt, distinct: PACK_RE.test(alt) ? undefined : "family" }));
          });
        })
        .then(function (res) {
          if (seq !== self.__fdpSeq) return null;
          if (!CFG.b2b) {
            // Count the search once typing has settled (not every keystroke).
            clearTimeout(self.__fdpLogTimer);
            self.__fdpPending = { type: "search", source: "dropdown", q: term, results: res.estimatedTotalHits, relaxed_to: relaxedTo };
            self.__fdpLogTimer = setTimeout(function () { logDropdownSearch(self); }, 1500);
          }
          var rows = isMobile(); // phones get the compact list; desktop keeps the card grid
          if (rows || !CFG.b2b) {
            // The phone rows are a photo and a name, no prices, so company buyers can have them too.
            var hits = res.hits.slice(0, rows ? MOBILE_ROWS : limit);
            var cards = hits.map(function (h) { return { handle: h.handle, html: rows ? instantRow(h) : instantCard(h, "div") }; });
            self.renderSearchResults(dropdownMarkup(term, res, cards, relaxedTo, rows));
            afterCardsInserted(self.predictiveSearchResults);
            track("dropdown", { search_term: term, results: res.estimatedTotalHits, relaxed_to: relaxedTo });
            if (rows) return null; // rows come from the index; no Shopify cards to swap in
            // Swap in Shopify's cards once they arrive, as long as the shopper hasn't typed on.
            renderCards(hits.map(function (h) { return h.handle; }), "fdp-cards-mini").then(function (real) {
              if (seq !== self.__fdpSeq) return;
              real.forEach(function (c) {
                var el = self.predictiveSearchResults.querySelector('[data-fdp-handle="' + c.handle.replace(/"/g, '\\"') + '"][data-fdp-instant]');
                if (el) el.outerHTML = c.html;
              });
              afterCardsInserted(self.predictiveSearchResults);
            });
            return null;
          }
          return renderCards(res.hits.map(function (h) { return h.handle; }), "fdp-cards-mini").then(function (cards) {
            return { res: res, cards: cards.slice(0, limit) };
          });
        })
        .then(function (r) {
          if (!r || seq !== self.__fdpSeq) return; // a newer keystroke won
          self.renderSearchResults(dropdownMarkup(term, r.res, r.cards, relaxedTo));
          afterCardsInserted(self.predictiveSearchResults);
          track("dropdown", { search_term: term, results: r.res.estimatedTotalHits, relaxed_to: relaxedTo });
        })
        .catch(function (e) {
          // Meilisearch unreachable: show Shopify's own suggestions instead of nothing.
          console.warn("[fdp-meili] dropdown, falling back to Shopify", e);
          if (seq === self.__fdpSeq) shopifyResults.call(self, term);
        });
      }
    };
  }

  // ---------------------------------------------------------------------------------------------
  // /search page

  function SearchPage(root) {
    this.root = root;
    this.perPage = parseInt(root.dataset.perPage, 10) || 48;
    this.grid = root.querySelector("[data-fdp-grid]");
    this.sidebar = root.querySelector("[data-fdp-sidebar]");
    this.countEl = root.querySelector("[data-fdp-count]");
    this.sortEl = root.querySelector("[data-fdp-sort]");
    this.activeEl = root.querySelector("[data-fdp-active]");
    this.emptyEl = root.querySelector("[data-fdp-empty]");
    this.pagerEl = root.querySelector("[data-fdp-pager]");
    this.titleEl = root.querySelector("[data-fdp-title]");
    this.noticeEl = root.querySelector("[data-fdp-notice]");
    this.state = this.readUrl();
    this.seq = 0;
    this.bind();
    var self = this;
    trackContainer(this.grid, "page", function () { return self.state.q; });
  }

  SearchPage.prototype.readUrl = function () {
    var p = new URLSearchParams(location.search);
    var st = { q: cleanQuery(p.get("original_q") || p.get("q")), page: Math.max(1, parseInt(p.get("page"), 10) || 1), sort: p.get("sort_by") || "", filters: {}, price: p.get("f.price") || "", packs: p.get("packs") === "all" };
    FACETS.concat([{ attr: "category3" }]).forEach(function (f) {
      var vals = p.getAll("f." + f.attr);
      if (vals.length) st.filters[f.attr] = vals;
    });
    return st;
  };

  SearchPage.prototype.writeUrl = function (push) {
    var s = this.state, p = new URLSearchParams();
    p.set("q", s.q);
    p.set("type", "product");
    if (s.sort) p.set("sort_by", s.sort);
    if (s.page > 1) p.set("page", s.page);
    if (s.price) p.set("f.price", s.price);
    if (s.packs) p.set("packs", "all");
    Object.keys(s.filters).forEach(function (a) { s.filters[a].forEach(function (v) { p.append("f." + a, v); }); });
    var url = location.pathname + "?" + p.toString();
    history[push ? "pushState" : "replaceState"]({}, "", url);
  };

  SearchPage.prototype.bind = function () {
    var self = this;
    this.sortEl.value = this.state.sort;
    this.sortEl.addEventListener("change", function () { self.state.sort = self.sortEl.value; self.state.page = 1; self.run(true); });
    var toggle = this.root.querySelector("[data-fdp-filters-toggle]");
    if (toggle) toggle.addEventListener("click", function () { self.sidebar.classList.toggle("is-open"); });
    this.sidebar.addEventListener("change", function (e) {
      var input = e.target;
      if (input.name === "fdp-price") {
        self.state.price = input.checked ? input.value : "";
      } else if (input.name === "fdp-packs") {
        self.state.packs = input.checked;
      } else if (input.dataset.attr) {
        var list = self.state.filters[input.dataset.attr] || [];
        list = list.filter(function (v) { return v !== input.value; });
        if (input.checked) list.push(input.value);
        if (list.length) self.state.filters[input.dataset.attr] = list; else delete self.state.filters[input.dataset.attr];
      }
      self.state.page = 1;
      self.run(true);
    });
    this.activeEl.addEventListener("click", function (e) {
      var chip = e.target.closest("[data-remove]");
      if (!chip) return;
      var attr = chip.dataset.remove, val = chip.dataset.value;
      if (attr === "price") self.state.price = "";
      else if (attr === "all") { self.state.filters = {}; self.state.price = ""; }
      else {
        self.state.filters[attr] = (self.state.filters[attr] || []).filter(function (v) { return v !== val; });
        if (!self.state.filters[attr].length) delete self.state.filters[attr];
      }
      self.state.page = 1;
      self.run(true);
    });
    this.pagerEl.addEventListener("click", function (e) {
      var b = e.target.closest("button[data-page]");
      if (!b) return;
      self.state.page = parseInt(b.dataset.page, 10);
      self.run(true);
      self.root.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    window.addEventListener("popstate", function () { self.state = self.readUrl(); self.sortEl.value = self.state.sort; self.run(false); });
  };

  SearchPage.prototype.filterExpr = function (exceptAttr) {
    var s = this.state, parts = baseFilters().slice();
    Object.keys(s.filters).forEach(function (a) {
      if (a === exceptAttr) return;
      parts.push(a + " IN [" + s.filters[a].map(quote).join(", ") + "]");
    });
    if (s.price && exceptAttr !== "price") {
      var r = PRICE_RANGES.filter(function (x) { return x.id === s.price; })[0];
      if (r) parts.push(r.filter);
    }
    return parts;
  };

  SearchPage.prototype.run = function (push) {
    var self = this, s = this.state, seq = ++this.seq;
    var redirect = redirectFor(s.q);
    if (redirect && !Object.keys(s.filters).length && !s.price) { location.replace(redirect); return; }
    if (push !== undefined) this.writeUrl(push);
    this.titleEl.textContent = s.q ? "Results for “" + s.q + "”" : "Search";
    if (!s.q) { this.renderEmpty("Enter a search term to find products."); return; }

    this.showSkeleton();

    self.query(s.q)
      .then(function (r) {
        if (r.res.totalHits > 0) return r;
        return findRelaxed(s.q, self.filterExpr(), r.collapse).then(function (alt) {
          if (!alt) return r;
          return self.query(alt).then(function (r2) { r2.relaxedTo = alt; return r2; });
        });
      })
      .then(function (r) {
        if (seq !== self.seq) return r;
        if (!CFG.b2b) {
          // Paint from the index immediately; Shopify's cards swap in underneath.
          r.cards = r.res.hits.map(function (h) { return { handle: h.handle, html: instantCard(h, "li") }; });
          self.render(r.res, r.facets, r.cards, r.collapse, r.relaxedTo);
          self.logSearch(r);
          self.upgradeCards(r.res.hits.map(function (h) { return h.handle; }), seq);
          track("results", { search_term: s.q, results: r.res.totalHits, page: s.page, relaxed_to: r.relaxedTo || null });
          return null;
        }
        // B2B: prices must come from Shopify, so wait for the real cards.
        var handles = r.res.hits.map(function (h) { return h.handle; });
        r.rest = handles.slice(FIRST_PAINT);
        return renderCards(handles.slice(0, FIRST_PAINT), "fdp-cards").then(function (cards) {
          r.cards = cards;
          return r;
        });
      })
      .then(function (r) {
        if (!r || seq !== self.seq) return;
        self.render(r.res, r.facets, r.cards, r.collapse, r.relaxedTo);
        self.logSearch(r);
        if (r.rest.length) {
          renderCards(r.rest, "fdp-cards").then(function (more) {
            if (seq !== self.seq || !more.length) return;
            self.grid.insertAdjacentHTML("beforeend", more.map(function (c) { return c.html; }).join(""));
            afterCardsInserted(self.grid);
          });
        }
        track("results", { search_term: s.q, results: r.res.totalHits, page: s.page, relaxed_to: r.relaxedTo || null });
      })
      .catch(function (e) {
        // Meilisearch unreachable: Shopify's own results page instead of an error.
        console.warn("[fdp-meili] results, falling back to Shopify", e);
        if (seq === self.seq) location.replace(nativeSearchUrl());
      });
  };

  /** One results query for `q` with the current filters/sort/page, plus disjunctive facet counts. */
  SearchPage.prototype.query = function (q) {
    var self = this, s = this.state;
    var collapse = !s.packs && !PACK_RE.test(q);
    var main = {
      indexUid: CFG.index,
      q: q,
      matchingStrategy: "all",
      attributesToRetrieve: CARD_FIELDS,
      filter: this.filterExpr(),
      hitsPerPage: this.perPage,
      page: s.page,
      facets: FACETS.map(function (f) { return f.attr; }),
    };
    if (collapse) main.distinct = "family";
    if (s.sort) main.sort = [s.sort];

    // Disjunctive facets: each facet with a selection gets counts computed without its own filter.
    var extra = Object.keys(s.filters).map(function (a) {
      var fq = { indexUid: CFG.index, q: q, matchingStrategy: "all", filter: self.filterExpr(a), limit: 0, facets: [a] };
      if (collapse) fq.distinct = "family";
      return fq;
    });

    // The <head> snippet may already have this exact query in flight.
    var preloaded =
      CFG.preload && CFG.preload.q === q && !extra.length && s.page === 1 && !s.sort && this.perPage === CFG.preloadPerPage
        ? CFG.preload.promise
        : null;
    CFG.preload = null; // only useful for the first render

    return (preloaded || fetch(CFG.host + "/multi-search", {
      method: "POST",
      headers: { Authorization: "Bearer " + CFG.key, "Content-Type": "application/json" },
      body: JSON.stringify({ queries: [main].concat(extra) }),
    }).then(function (r) { if (!r.ok) throw new Error("search failed: " + r.status); return r.json(); }))
      .then(function (data) {
        if (!data) throw new Error("search failed");
        var res = data.results[0];
        var facets = Object.assign({}, res.facetDistribution || {});
        data.results.slice(1).forEach(function (x) { Object.assign(facets, x.facetDistribution || {}); });
        return { res: res, facets: facets, collapse: collapse };
      });
  };

  /** One "search" event per query shown on this page (filter/sort/page changes aren't new searches). */
  SearchPage.prototype.logSearch = function (r) {
    if (this.loggedQuery === this.state.q) return;
    this.loggedQuery = this.state.q;
    log({ type: "search", source: "page", q: this.state.q, results: r.res.totalHits, relaxed_to: r.relaxedTo || null });
  };

  /** Replace instant cards with Shopify-rendered ones (add to cart, swatches, badges), in batches. */
  SearchPage.prototype.upgradeCards = function (handles, seq) {
    var self = this;
    var batches = [];
    for (var i = 0; i < handles.length; i += CARD_BATCH) batches.push(handles.slice(i, i + CARD_BATCH));
    batches.reduce(function (chain, batch) {
      return chain.then(function () {
        if (seq !== self.seq) return;
        return renderCards(batch, "fdp-cards").then(function (cards) {
          if (seq !== self.seq) return;
          var seen = {};
          cards.forEach(function (c) {
            seen[c.handle] = true;
            var el = self.grid.querySelector('[data-fdp-handle="' + c.handle.replace(/"/g, '\\"') + '"][data-fdp-instant]');
            if (el) el.outerHTML = c.html;
          });
          // Anything Shopify won't render for this shopper shouldn't stay on the page.
          batch.forEach(function (h) {
            if (seen[h]) return;
            var el = self.grid.querySelector('[data-fdp-handle="' + h.replace(/"/g, '\\"') + '"][data-fdp-instant]');
            if (el) el.remove();
          });
          afterCardsInserted(self.grid);
        });
      });
    }, Promise.resolve()).catch(function (e) { console.warn("[fdp-meili] card upgrade", e); });
  };

  /** Grey placeholder cards while the first results load. */
  SearchPage.prototype.showSkeleton = function () {
    if (this.grid.querySelector("li.product")) { this.grid.classList.add("is-loading"); return; }
    var cells = "";
    for (var i = 0; i < FIRST_PAINT; i++) cells += '<li class="fdp-ms__skeleton" aria-hidden="true"></li>';
    this.grid.innerHTML = cells;
  };

  SearchPage.prototype.renderEmpty = function (msg) {
    this.grid.classList.remove("is-loading");
    this.grid.innerHTML = "";
    this.pagerEl.innerHTML = "";
    this.countEl.textContent = "";
    this.emptyEl.hidden = false;
    if (this.noticeEl) this.noticeEl.hidden = true;
    this.emptyEl.innerHTML = "<p>" + esc(msg) + "</p>";
  };

  SearchPage.prototype.render = function (res, facets, cards, collapsed, relaxedTo) {
    var s = this.state, self = this;
    if (this.noticeEl) {
      this.noticeEl.hidden = !relaxedTo;
      this.noticeEl.innerHTML = relaxedTo
        ? "No exact matches for “" + esc(s.q) + "”. Showing results for “<strong>" + esc(relaxedTo) + "</strong>”."
        : "";
    }
    this.grid.classList.remove("is-loading");
    this.emptyEl.hidden = cards.length > 0;
    if (!cards.length) {
      this.emptyEl.innerHTML = "<p>No products found for “" + esc(s.q) + "”" + (Object.keys(s.filters).length || s.price ? " with these filters." : ".") + "</p>";
    }
    this.grid.classList.remove("is-loading");
    this.grid.innerHTML = cards.map(function (c) { return c.html; }).join("");
    afterCardsInserted(this.grid);
    this.countEl.textContent = res.totalHits + (res.totalHits === 1 ? " product" : " products");

    // sidebar
    var html = "";
    html += '<div class="fdp-ms__facet"><label class="fdp-ms__packs"><input type="checkbox" name="fdp-packs"' + (s.packs ? " checked" : "") + (PACK_RE.test(s.q) ? " disabled checked" : "") + "> Show every pack size</label></div>";
    FACETS.forEach(function (f) {
      var dist = facets[f.attr] || {};
      var selected = s.filters[f.attr] || [];
      var values = Object.keys(dist);
      selected.forEach(function (v) { if (values.indexOf(v) < 0) values.push(v); });
      if (!values.length) return;
      values.sort(function (a, b) { return (dist[b] || 0) - (dist[a] || 0) || a.localeCompare(b); });
      html += '<details class="fdp-ms__facet"' + (selected.length || ["category1", "license", "color"].indexOf(f.attr) >= 0 ? " open" : "") + "><summary>" + esc(f.label) + "</summary><ul class=\"fdp-ms__opts\">";
      values.slice(0, 60).forEach(function (v) {
        var on = selected.indexOf(v) >= 0;
        html += '<li><label><input type="checkbox" data-attr="' + f.attr + '" value="' + esc(v) + '"' + (on ? " checked" : "") + "> " + esc(v) + ' <span class="n">' + (dist[v] || 0) + "</span></label></li>";
      });
      html += "</ul></details>";
    });
    html += '<details class="fdp-ms__facet" open><summary>Price</summary><ul class="fdp-ms__opts">';
    PRICE_RANGES.forEach(function (r) {
      html += '<li><label><input type="checkbox" name="fdp-price" value="' + r.id + '"' + (s.price === r.id ? " checked" : "") + "> " + esc(r.label) + "</label></li>";
    });
    html += "</ul></details>";
    this.sidebar.innerHTML = html;
    // one price range at a time
    this.sidebar.querySelectorAll('input[name="fdp-price"]').forEach(function (el) {
      el.addEventListener("click", function () {
        self.sidebar.querySelectorAll('input[name="fdp-price"]').forEach(function (o) { if (o !== el) o.checked = false; });
      });
    });

    // active chips
    var chips = [];
    Object.keys(s.filters).forEach(function (a) {
      s.filters[a].forEach(function (v) { chips.push('<button type="button" class="fdp-ms__chip" data-remove="' + a + '" data-value="' + esc(v) + '">' + esc(v) + " ×</button>"); });
    });
    if (s.price) {
      var pr = PRICE_RANGES.filter(function (x) { return x.id === s.price; })[0];
      if (pr) chips.push('<button type="button" class="fdp-ms__chip" data-remove="price">' + esc(pr.label) + " ×</button>");
    }
    if (chips.length > 1) chips.push('<button type="button" class="fdp-ms__chip" data-remove="all">Clear all</button>');
    this.activeEl.innerHTML = chips.join("");

    // pager
    var pages = res.totalPages || 1, cur = s.page, out = "";
    if (pages > 1) {
      var btn = function (n, label) { return '<button type="button" data-page="' + n + '"' + (n === cur ? ' aria-current="page"' : "") + ">" + (label || n) + "</button>"; };
      if (cur > 1) out += btn(cur - 1, "‹ Prev");
      var from = Math.max(1, cur - 2), to = Math.min(pages, cur + 2);
      if (from > 1) out += btn(1) + (from > 2 ? "<span>…</span>" : "");
      for (var n = from; n <= to; n++) out += btn(n);
      if (to < pages) out += (to < pages - 1 ? "<span>…</span>" : "") + btn(pages);
      if (cur < pages) out += btn(cur + 1, "Next ›");
    }
    this.pagerEl.innerHTML = out;
  };

  // ---------------------------------------------------------------------------------------------
  // "Trending Now" panel (desktop): live top searches + best-selling / in-season products,
  // refreshed daily by the fdp-search server from Shopify analytics. Falls back to the theme's
  // static settings if the data isn't available.

  function liveTrending() {
    var blocks = [].slice.call(document.querySelectorAll("[data-quick-trending-products]"));
    if (!blocks.length) return;
    var mark = function (state) { blocks.forEach(function (b) { if (!b.dataset.fdpTrending) b.dataset.fdpTrending = state; }); };
    if (!CFG.trendingPromise || isMobile()) { mark("static"); return; }
    // Never leave the panel hidden: show the theme's own content if live data is slow or missing.
    var giveUp = setTimeout(function () { mark("static"); }, 3000);

    CFG.trendingPromise
      .then(function (data) {
        if (!data || (!(data.terms || []).length && !(data.products || []).length)) { clearTimeout(giveUp); mark("static"); return; }
        var terms = (data.terms || []).map(function (t) { return t.term; });
        var products = data.products || [];

        if (terms.length) {
          var items = terms.map(function (t) {
            return '<li class="item"><a href="' + esc(CFG.searchUrl + "?q=" + encodeURIComponent(t) + "&type=product") +
              '" class="link"><span class="text">' + esc(t) + "</span></a></li>";
          }).join("");
          blocks.forEach(function (b) {
            var ul = b.querySelector(".quickSearchTrending ul");
            if (ul) ul.innerHTML = items;
          });
        }

        var grids = blocks.map(function (b) { return b.querySelector(".quickSearchProduct .products-grid"); }).filter(Boolean);
        var handles = products.map(function (p) { return p.handle; });
        var upgrade = function () {
          // Shopify's cards (swatches, add to cart, B2B prices) replace the instant ones.
          return renderCards(handles, "fdp-cards-mini").then(function (cards) {
            if (!cards.length) return;
            var html = cards.map(function (c) { return c.html; }).join("");
            grids.forEach(function (g) { g.innerHTML = html; afterCardsInserted(g); });
          });
        };

        if (!products.length || !grids.length) { clearTimeout(giveUp); mark("live"); return; }
        if (!CFG.b2b) {
          // Draw immediately from the data we already have, then upgrade.
          var instant = products.map(function (p) { return instantCard(p, "div"); }).join("");
          grids.forEach(function (g) { g.innerHTML = instant; });
          clearTimeout(giveUp);
          mark("live");
          upgrade();
        } else {
          // B2B prices differ from the index, so wait for Shopify's cards.
          upgrade().then(function () { clearTimeout(giveUp); mark("live"); }, function () { mark("static"); });
        }
      })
      .catch(function (e) { console.warn("[fdp-meili] trending", e); mark("static"); });
  }

  // ---------------------------------------------------------------------------------------------
  // typing placeholder: "Search for table covers" types out, deletes, next idea

  function typingPlaceholder() {
    var ideas = (CFG.placeholderIdeas || []).filter(Boolean);
    var prefix = CFG.placeholderPrefix || "Search for ";
    // The theme's text ("general.search.search_product") is "Search for", the animation's own first frame.
    var inputs = [].slice.call(document.querySelectorAll('form.search input[type="search"], form[action*="/search"] input[name="q"]'));
    // The mobile header shows a tap target with the placeholder as plain text, not an input.
    var spans = [].slice.call(document.querySelectorAll(".fdp-search-trigger-text"));
    if (!ideas.length || (!inputs.length && !spans.length)) return;
    inputs.forEach(function (i) { if (!i.getAttribute("aria-label")) i.setAttribute("aria-label", "Search products"); });
    var set = function (text) {
      inputs.forEach(function (i) { i.setAttribute("placeholder", text); });
      spans.forEach(function (sp) { sp.textContent = text; });
    };

    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      set(prefix + ideas[0]);
      return;
    }

    var idea = 0, chars = 0, deleting = false;
    (function tick() {
      var word = ideas[idea];
      set(prefix + word.slice(0, chars));
      var delay;
      if (!deleting && chars < word.length) { chars++; delay = 85; }
      else if (!deleting) { deleting = true; delay = 1600; }          // hold the full idea
      else if (chars > 0) { chars--; delay = 40; }
      else { deleting = false; idea = (idea + 1) % ideas.length; delay = 350; }
      setTimeout(tick, document.hidden ? 1000 : delay);
    })();
  }

  // ---------------------------------------------------------------------------------------------
  // boot

  function boot() {
    // A few companies buy from catalogs the index can't see, so they keep Shopify's own search.
    if (CFG.nativeSearch) {
      useNativeSearch();
      typingPlaceholder();
      document.querySelectorAll("[data-quick-trending-products]").forEach(function (b) { b.dataset.fdpTrending = "static"; });
      // The hand-off worked, so let the next search try it again (see sections/fdp-meili-search.liquid).
      if (/[?&]view=native\b/.test(location.search)) {
        try { sessionStorage.removeItem("fdp_native_retry"); } catch (e) { /* private mode */ }
        return;
      }
      // Still on this page: the hand-off didn't stick, so render results here instead of a blank page.
      var nativeRoot = document.querySelector("[data-fdp-meili-search]");
      if (nativeRoot) new SearchPage(nativeRoot).run(false);
      return;
    }
    if (customElements.get("predictive-search")) patchPredictiveSearch();
    else customElements.whenDefined("predictive-search").then(patchPredictiveSearch);

    var root = document.querySelector("[data-fdp-meili-search]");
    if (root) new SearchPage(root).run(false); // replaceState: drop the theme's extra form params from the URL

    typingPlaceholder();
    trackProductPageAddToCart();
    // The trending panel draws from the index, whose prices are retail; company buyers keep the
    // theme's own panel, which Shopify renders.
    if (CFG.b2b) document.querySelectorAll("[data-quick-trending-products]").forEach(function (b) { b.dataset.fdpTrending = "static"; });
    else liveTrending(); // data was requested from <head>, so this is usually ready already
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
